import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-edit" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "columns-section" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "checkbox-label" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }

import { ref, watch, computed } from "vue";

interface Props {
  block: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableEdit',
  props: {
    block: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const localBlock = ref(JSON.parse(JSON.stringify(props.block)));

// Inicializar dados se não existirem
if (!localBlock.value.data) {
  localBlock.value.data = {
    title: "Tabela",
    dataKey: "parametros",
    columns: [],
    data: [],
  };
}

if (!localBlock.value.style) {
  localBlock.value.style = {
    border: "1px solid #dee2e6",
  };
}

// Computed properties para os controles
const tableHeaderColor = computed({
  get: () => localBlock.value.style["--header-bg"] || "#f8f9fa",
  set: (value) => {
    localBlock.value.style["--header-bg"] = value;
    onChange();
  },
});

const stripedRows = computed({
  get: () => localBlock.value.style["--striped"] === "true",
  set: (value) => {
    localBlock.value.style["--striped"] = value.toString();
    onChange();
  },
});

const roundedBorder = computed({
  get: () => localBlock.value.style.borderRadius === "8px",
  set: (value) => {
    localBlock.value.style.borderRadius = value ? "8px" : "0";
    onChange();
  },
});

watch(
  () => props.block,
  (newBlock) => {
    localBlock.value = JSON.parse(JSON.stringify(newBlock));
  },
  { deep: true }
);

function onChange() {
  emit("update", localBlock.value);
}

function onDataKeyChange() {
  // Carregar colunas padrão baseado na chave selecionada
  const columnsMap: any = {
    parametros: [
      { key: "parameter", label: "Parâmetro", editable: true },
      { key: "value", label: "Valor Medido", editable: true },
      { key: "limit", label: "Limite", editable: true },
      { key: "unit", label: "Unidade", editable: true },
      { key: "status", label: "Status", editable: false },
    ],
    resultados: [
      { key: "item", label: "Item", editable: true },
      { key: "result", label: "Resultado", editable: true },
      { key: "reference", label: "Referência", editable: true },
    ],
    limites: [
      { key: "substance", label: "Substância", editable: true },
      { key: "limit", label: "Limite", editable: true },
      { key: "unit", label: "Unidade", editable: true },
    ],
  };

  if (localBlock.value.data.dataKey !== "custom") {
    localBlock.value.data.columns =
      columnsMap[localBlock.value.data.dataKey] || [];
  }

  onChange();
}

function addColumn() {
  if (!localBlock.value.data.columns) {
    localBlock.value.data.columns = [];
  }
  localBlock.value.data.columns.push({
    key: `col${localBlock.value.data.columns.length + 1}`,
    label: `Coluna ${localBlock.value.data.columns.length + 1}`,
    editable: true,
  });
  onChange();
}

function removeColumn(index: number) {
  localBlock.value.data.columns.splice(index, 1);
  onChange();
}

function onHeaderColorChange() {
  onChange();
}

function onStripedChange() {
  onChange();
}

function onRoundedChange() {
  onChange();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("h4", null, "Editar Tabela", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("label", null, "Título:", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localBlock.value.data.title) = $event)),
        onInput: onChange,
        type: "text",
        placeholder: "Título da tabela"
      }, null, 544), [
        [_vModelText, localBlock.value.data.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[8] || (_cache[8] = _createElementVNode("label", null, "Chave dos Dados:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localBlock.value.data.dataKey) = $event)),
        onChange: onDataKeyChange
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("option", { value: "parametros" }, "Parâmetros Avaliados", -1),
        _createElementVNode("option", { value: "resultados" }, "Resultados", -1),
        _createElementVNode("option", { value: "limites" }, "Limites Toleráveis", -1),
        _createElementVNode("option", { value: "custom" }, "Personalizado", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.data.dataKey]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", { class: "section-header" }, [
        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Colunas:", -1)),
        _createElementVNode("button", {
          onClick: addColumn,
          type: "button",
          class: "btn-add"
        }, "+")
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localBlock.value.data.columns, (column, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "column-item"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((column.label) = $event),
            onInput: onChange,
            placeholder: "Nome da coluna",
            class: "column-label"
          }, null, 40, _hoisted_5), [
            [_vModelText, column.label]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((column.key) = $event),
            onInput: onChange,
            placeholder: "Chave",
            class: "column-key"
          }, null, 40, _hoisted_6), [
            [_vModelText, column.key]
          ]),
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((column.editable) = $event),
              onChange: onChange
            }, null, 40, _hoisted_8), [
              [_vModelCheckbox, column.editable]
            ]),
            _cache[10] || (_cache[10] = _createTextVNode(" Editável ", -1))
          ]),
          _createElementVNode("button", {
            onClick: ($event: any) => (removeColumn(index)),
            type: "button",
            class: "btn-remove"
          }, " × ", 8, _hoisted_9)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("label", null, "Estilo da Tabela:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localBlock.value.style.border) = $event)),
        onChange: onChange
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("option", { value: "1px solid #dee2e6" }, "Borda Padrão", -1),
        _createElementVNode("option", { value: "2px solid #333" }, "Borda Forte", -1),
        _createElementVNode("option", { value: "none" }, "Sem Borda", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.border]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Cor do Cabeçalho:", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "color",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tableHeaderColor).value = $event)),
        onChange: onHeaderColorChange
      }, null, 544), [
        [_vModelText, tableHeaderColor.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[14] || (_cache[14] = _createElementVNode("label", null, "Linhas Zebradas:", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((stripedRows).value = $event)),
        onChange: onStripedChange
      }, null, 544), [
        [_vModelCheckbox, stripedRows.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[15] || (_cache[15] = _createElementVNode("label", null, "Borda Arredondada:", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((roundedBorder).value = $event)),
        onChange: onRoundedChange
      }, null, 544), [
        [_vModelCheckbox, roundedBorder.value]
      ])
    ])
  ]))
}
}

})